const untrackUser = () => {
  if (!window._paq) return;

  window._paq.push(['resetUserId']);
  window._paq.push(['appendToTrackingUrl', 'new_visit=1']);
};

export default untrackUser;
